import React, { Component } from 'react';
import Header from './header';
import TrackerTag from './tracker';

export default class EventComponent extends Component {
    render() {
        return (
            <div style={{ height: '90px', width: '100%', marginBottom: '8px' }} >
                <Header event={this.props.event} />
                <div style={{ position: 'relative', left: '0px', top: '18px' }}>
                    <TrackerTag event={this.props.event} />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/schedule/issues/issues.js